/* Alarie - barra flotante, galeria, packs, pestanas, pastilla de compra,
   recomendaciones y la cuenta atras de la oferta. */
(function () {
  'use strict';
  if (window.__alarieHearo) return;
  window.__alarieHearo = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scroller(from) {
    if (window.AlarieScroll) return window.AlarieScroll.container(from || document.body);
    return document.scrollingElement || document.documentElement;
  }
  function top(el) {
    if (window.AlarieScroll) return window.AlarieScroll.top(el);
    return window.scrollY || 0;
  }
  /* Scroll real de la pagina: en Horizon unas veces se mueve la ventana y otras
     .page-wrapper, segun la pagina y el momento. Nos quedamos con el mayor. */
  function curY() {
    var pw = document.querySelector('.page-wrapper');
    var se = document.scrollingElement || document.documentElement;
    return Math.max(window.scrollY || 0, se ? se.scrollTop : 0, pw ? pw.scrollTop : 0);
  }
  function onScroll(from, fn) {
    if (window.AlarieScroll) window.AlarieScroll.on(from, fn);
    else { window.addEventListener('scroll', fn, { passive: true }); window.addEventListener('resize', fn, { passive: true }); }
    fn();
  }

  /* ---------- barra flotante ----------
     Como la de Noara: no sustituye a la cabecera, es un elemento aparte que
     esta escondido y solo se muestra cuando ya has bajado un poco y vuelves a
     subir. Al bajar se esconde otra vez, y arriba del todo manda la cabecera. */
  function floatbar() {
    var fl = document.querySelector('[data-fl]');
    if (!fl || fl.dataset.bound === '1') return;
    fl.dataset.bound = '1';
    if (reduce) return;

    var last = curY();
    var on = false;

    onScroll(fl, function () {
      var y = curY();
      var d = y - last;
      if (Math.abs(d) < 5) return;
      last = y;
      var should = y > 360 && d < 0;
      if (y < 160) should = false;
      if (should !== on) { on = should; fl.classList.toggle('is-on', on); }
    });
  }

  /* ---------- cuenta atras de la oferta ----------
     Igual para todo el mundo: cuenta lo que falta hasta la hora de reinicio
     (por defecto las 5:00) en hora de Espana peninsular, sea cual sea la zona
     horaria del movil. Ahora va por ciclos de 12 horas: a las 12:00 y a las 00:00 vuelve a empezar desde 12:00:00. */
  function clock() {
    var els = document.querySelectorAll('[data-promo-clock]');
    if (!els.length) return;
    var hr = parseInt(els[0].getAttribute('data-reset-hour'), 10);
    if (isNaN(hr) || hr < 0 || hr > 23) hr = 5;
    var fmt = null;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hour12: false,
        hour: '2-digit', minute: '2-digit', second: '2-digit' });
    } catch (e) { fmt = null; }
    function madridSecs() {
      var d = new Date();
      if (fmt) {
        var h = 0, m = 0, s = 0;
        fmt.formatToParts(d).forEach(function (p) {
          if (p.type === 'hour') h = parseInt(p.value, 10) % 24;
          if (p.type === 'minute') m = parseInt(p.value, 10);
          if (p.type === 'second') s = parseInt(p.value, 10);
        });
        return h * 3600 + m * 60 + s;
      }
      /* navegador muy antiguo: aproxima con UTC+1 */
      return ((d.getUTCHours() + 1) % 24) * 3600 + d.getUTCMinutes() * 60 + d.getUTCSeconds();
    }
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      /* ciclos de 12 horas: se reinicia a las 12:00 y a las 00:00 (hora de Espana) */
      var left = 43200 - madridSecs() % 43200;
      if (left === 0) left = 43200;
      var h = pad(Math.floor(left / 3600)), m = pad(Math.floor(left / 60) % 60), q = pad(left % 60);
      Array.prototype.forEach.call(els, function (e) {
        var a = e.querySelector('[data-h]'), b = e.querySelector('[data-m]'), c = e.querySelector('[data-s]');
        if (a) a.textContent = h;
        if (b) b.textContent = m;
        if (c) c.textContent = q;
      });
      window.setTimeout(tick, 1000 - (Date.now() % 1000) + 5);
    }
    tick();
  }

  /* ---------- galeria ---------- */
  function gallery() {
    var main = document.querySelector('[data-pd-main]');
    if (!main) return;
    var track = document.querySelector('[data-pd-track]');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.al-pdThumb'));

    thumbs.forEach(function (b) {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-src');
        thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
        var img = main.querySelector('img');
        if (!img || !src || img.src === src) return;
        if (reduce) { img.src = src; return; }
        main.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = function () {
          img.src = src;
          window.requestAnimationFrame(function () { main.classList.remove('is-swapping'); });
        };
        pre.src = src;
      });
    });

    if (!track) return;
    var prev = document.querySelector('[data-pd-prev]');
    var next = document.querySelector('[data-pd-next]');
    function step(d) { track.scrollBy({ left: d * (track.clientWidth * 0.8), behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev && !prev.dataset.bound) { prev.dataset.bound = '1'; prev.addEventListener('click', function () { step(-1); }); }
    if (next && !next.dataset.bound) { next.dataset.bound = '1'; next.addEventListener('click', function () { step(1); }); }
  }

  /* ---------- colores y packs ---------- */
  function pickers() {
    var idField = document.getElementById('alVariantId');

    var sw = Array.prototype.slice.call(document.querySelectorAll('[data-sw]'));
    var label = document.querySelector('[data-sw-label]');
    sw.forEach(function (b) {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', function () {
        sw.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
        if (label) label.textContent = b.getAttribute('data-sw');
        if (idField && b.getAttribute('data-vid')) idField.value = b.getAttribute('data-vid');
      });
    });

    var packs = Array.prototype.slice.call(document.querySelectorAll('.al-pdPack'));
    var priceOut = document.querySelector('[data-add-price]');
    packs.forEach(function (l) {
      if (l.dataset.bound) return;
      l.dataset.bound = '1';
      l.addEventListener('click', function () {
        packs.forEach(function (x) { x.classList.remove('al-pdPack--sel'); });
        l.classList.add('al-pdPack--sel');
        var r = l.querySelector('input[type=radio]');
        if (r) r.checked = true;
        if (idField && l.getAttribute('data-vid')) idField.value = l.getAttribute('data-vid');
        var qty = document.getElementById('alQty');
        if (qty && l.getAttribute('data-qty')) qty.value = l.getAttribute('data-qty');
        if (priceOut && l.getAttribute('data-total')) priceOut.textContent = l.getAttribute('data-total');
      });
    });
  }

  /* ---------- pastilla flotante de compra ----------
     En la ficha sale SOLO cuando ya has pasado (hacia abajo) el boton de
     anadir; al abrir la ficha, con el boton aun por debajo, no sale.
     En el resto de paginas, al bajar media pantalla.
     Se esconde solo mientras en pantalla haya otro boton de compra (regalo,
     llamadas a la accion...), para no taparlo ni duplicarlo. Al final de la
     pagina y en el pie vuelve a salir, para que siempre haya un boton. */
  function buybar() {
    var bar = document.querySelector('.al-buybar');
    if (!bar || bar.dataset.bound === '1') return;
    bar.dataset.bound = '1';
    var form = document.getElementById('alForm');

    bar.addEventListener('click', function (e) {
      if (!form) return;
      e.preventDefault();
      /* en la ficha la pastilla dice "Anadir a la cesta": anade directamente */
      form.requestSubmit();
    });

    var formPassed = false, past = false, others = 0;
    function paint() { bar.classList.toggle('is-up', (form ? formPassed : past) && others === 0); }

    if ('IntersectionObserver' in window) {
      if (form) {
        new IntersectionObserver(function (entries) {
          /* pasado = ya no se ve y se ha quedado por ARRIBA de la pantalla */
          entries.forEach(function (en) { formPassed = !en.isIntersecting && en.boundingClientRect.bottom <= 0; });
          paint();
        }, { threshold: 0 }).observe(form);
      }
      /* otros botones de compra: mientras se ven, la pastilla se va */
      var seen = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) seen.add(en.target); else seen.delete(en.target); });
        others = seen.size;
        paint();
      }, { threshold: 0, rootMargin: '0px 0px 40px 0px' });
      Array.prototype.forEach.call(document.querySelectorAll('.al-btn'), function (el) {
        if (el !== bar && !bar.contains(el)) io.observe(el);
      });
    }
    if (!form) {
      onScroll(document.body, function () {
        past = curY() > window.innerHeight * 0.5;
        paint();
      });
    }
  }

  /* ---------- recomendaciones ---------- */
  function experts() {
    var root = document.querySelector('[data-exp]');
    if (!root || root.dataset.bound === '1') return;
    root.dataset.bound = '1';
    var cards = Array.prototype.slice.call(root.querySelectorAll('.al-exp'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.al-exp__dot'));
    if (cards.length < 2) { dots.forEach(function (d) { d.style.display = 'none'; }); return; }
    function show(i) {
      cards.forEach(function (c, k) { c.style.display = k === i ? '' : 'none'; });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });
    show(0);
  }

  function init() { floatbar(); clock(); gallery(); pickers(); buybar(); experts(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
